import { Outlet } from "react-router";

type Props = {};

const Doctor = (props: Props) => {
  return <Outlet />;
};

export default Doctor;
